/**
 * Admin page rendered at "/admin/submissions" (nested route inside AdminHomepage,
 * which is mounted at "/admin/*" behind an admin-only ProtectedRoute). Wraps a single
 * "submissions" tab in TabbedPage that shows an AdminListViewContainer for regular
 * (non-AI) bounty submissions; clicking a row opens SubmissionDisplay in owner mode.
 */
import TabbedPage from "@/components/TabbedPage";
import AdminListViewContainer from "@/pages/admin/AdminListViewContainer";
import React from "react";

const SubmissionsAdminPage: React.FC = () => {
    return (
        <TabbedPage
            tabs={[
                {
                    tabName: "submissions",
                    render: () => (
                        <AdminListViewContainer key="submissions" listItemType="submission" />
                    ),
                },
            ]}
        />
    );
};

export default SubmissionsAdminPage;
